var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      class: { "grid-list-md": _vm.isMobile, "grid-list-lg": !_vm.isMobile },
      attrs: { "px-0": "" }
    },
    [
      _c("v-form", { ref: "serviceInformation" }, [
        _vm.action !== "edit" && _vm.action !== "copy" && _vm.signature
          ? _c(
              "div",
              { staticStyle: { "padding-left": "25px" } },
              [
                _c("v-checkbox", {
                  attrs: {
                    id: "userCheckBox",
                    disabled: _vm.providerDisabled(),
                    color: "indigo darken-3",
                    "error-messages": _vm.checkedErrors,
                    messages: _vm.licenseAttestMessage,
                    label: "Provider Signature"
                  },
                  on: { change: _vm.onUserCheckboxClicked },
                  model: {
                    value:
                      _vm.student.form.serviceInformation.licenseAttestUserId,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.student.form.serviceInformation,
                        "licenseAttestUserId",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression:
                      "student.form.serviceInformation.licenseAttestUserId"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.action === "copy" && _vm.signature
          ? _c(
              "div",
              { staticStyle: { "padding-left": "25px" } },
              [
                _c("v-checkbox", {
                  key: _vm.componentKey,
                  attrs: {
                    id: "userCheckBoxCopy",
                    disabled: _vm.disabledCopy,
                    color: "indigo darken-3",
                    "error-messages": _vm.checkedErrors,
                    messages: _vm.licenseAttestMessage,
                    label: "Provider Signature"
                  },
                  on: { change: _vm.onUserCheckboxClickedCopy },
                  model: {
                    value: _vm.providerCheckCopy,
                    callback: function($$v) {
                      _vm.providerCheckCopy =
                        typeof $$v === "string" ? $$v.trim() : $$v
                    },
                    expression: "providerCheckCopy"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.action === "edit" &&
        this.supervisorFlagsArray.licenseAttestName &&
        _vm.signature
          ? _c(
              "div",
              { staticStyle: { "padding-left": "25px" } },
              [
                _c("v-checkbox", {
                  attrs: {
                    id: "userCheckBox",
                    disabled: _vm.providerDisabled(),
                    color: "indigo darken-3",
                    "error-messages": _vm.checkedErrors,
                    messages: _vm.licenseAttestMessage,
                    label: "Provider Signature"
                  },
                  on: { change: _vm.onUserCheckboxClicked },
                  model: {
                    value:
                      _vm.student.form.serviceInformation.licenseAttestUserId,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.student.form.serviceInformation,
                        "licenseAttestUserId",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression:
                      "student.form.serviceInformation.licenseAttestUserId"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.action === "edit" &&
        !this.supervisorFlagsArray.licenseAttestName &&
        _vm.signature
          ? _c(
              "div",
              { staticStyle: { "padding-left": "25px" } },
              [
                _c("v-checkbox", {
                  attrs: {
                    id: "userCheckBox",
                    disabled: _vm.providerDisabled(),
                    color: "indigo darken-3",
                    "error-messages": _vm.checkedErrors,
                    messages: _vm.licenseAttestMessage,
                    label: "Provider Signature"
                  },
                  on: { change: _vm.onUserCheckboxClicked },
                  model: {
                    value:
                      _vm.student.form.serviceInformation.licenseAttestUserId,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.student.form.serviceInformation,
                        "licenseAttestUserId",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression:
                      "student.form.serviceInformation.licenseAttestUserId"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.action === "edit" &&
        !this.supervisorFlagsArray.supervisorFlag &&
        this.supervisorFlagsArray.supervisorRequiredFlag &&
        _vm.signature
          ? _c(
              "div",
              { staticStyle: { "padding-left": "25px" } },
              [
                _c("v-checkbox", {
                  attrs: {
                    id: "supervisorCheckBox",
                    disabled: _vm.supervisorDisabled,
                    color: "indigo darken-3",
                    "error-messages": _vm.supervisorCheckedErrors,
                    messages: _vm.supervisorChecked2
                      ? this.student.form.serviceInformation.supervisorName +
                        ", " +
                        this.student.form.serviceInformation
                          .supervisorCredential +
                        " " +
                        _vm.getCurrentDate()
                      : "",
                    label: "Supervision Signature"
                  },
                  on: { change: _vm.onSupervisorCheckboxClicked2 },
                  model: {
                    value: _vm.student.form.serviceInformation.supervisorUserId,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.student.form.serviceInformation,
                        "supervisorUserId",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression:
                      "student.form.serviceInformation.supervisorUserId"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.action === "edit" &&
        this.supervisorFlagsArray.supervisorFlag &&
        this.supervisorFlagsArray.supervisorRequiredFlag &&
        _vm.signature
          ? _c(
              "div",
              { staticStyle: { "padding-left": "25px" } },
              [
                _c("v-checkbox", {
                  attrs: {
                    id: "supervisorCheckBox",
                    disabled: _vm.supervisorDisabled2,
                    color: "indigo darken-3",
                    "error-messages": _vm.supervisorCheckedErrors,
                    messages: _vm.supervisorChecked
                      ? this.student.form.serviceInformation.supervisorName +
                        ", " +
                        _vm.supervisorCredentialFill() +
                        " " +
                        _vm.calcDate()
                      : "",
                    label: "Supervision Signature"
                  },
                  on: { change: _vm.onSupervisorCheckboxClicked },
                  model: {
                    value: _vm.student.form.serviceInformation.supervisorUserId,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.student.form.serviceInformation,
                        "supervisorUserId",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression:
                      "student.form.serviceInformation.supervisorUserId"
                  }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aceaaa12", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aceaaa12","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service-log/form/extended-service-information/extended-service-information.vue
// module id = null
// module chunks = 